import { getKeycloakUserInfo } from '../services/keycloak';

/**
 * Check if the current user has admin role or is in admin group
 * @returns {boolean} True if user has admin privileges
 */
export const isUserAdmin = () => {
  const userInfo = getKeycloakUserInfo();

  // Debug logging to see what roles are actually available

  if (!userInfo) {
    return false;
  }

  // Check roles
  if (userInfo.roles && userInfo.roles.length > 0) {

    const isAdminRole = userInfo.roles.some(role =>
      role.toLowerCase() === 'admin' ||
      role.toLowerCase() === 'realm:admin' ||
      role.toLowerCase() === 'realm-admin' ||
      role.toLowerCase() === 'realm_admin'
    );

    if (isAdminRole) {
      return true;
    }
  }

  // Check groups
  if (userInfo.groups && userInfo.groups.length > 0) {

    const isAdminGroup = userInfo.groups.some(group => {
      const groupName = group.startsWith('/') ? group.substring(1) : group;
      return groupName.toLowerCase() === 'admin';
    });

    if (isAdminGroup) {
      return true;
    }
  }

  // Check if tokenParsed contains groups directly
  if (userInfo.tokenParsed && userInfo.tokenParsed.groups) {

    const isAdminGroup = userInfo.tokenParsed.groups.some(group => {
      const groupName = group.startsWith('/') ? group.substring(1) : group;
      return groupName.toLowerCase() === 'admin';
    });

    if (isAdminGroup) {
      return true;
    }
  }

  return false;
}; 